// extracted by mini-css-extract-plugin
export default {"container":"footer_container__Vze3y","footerTitle":"footer_footerTitle__A7HVi","button":"footer_button__n+XWy"};